var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLimitManagement',{attrs:{"items":_vm.items,"selected":_vm.itemsSelected,"loading":_vm.loading},on:{"delete":_vm.deleteSelected},scopedSlots:_vm._u([{key:"listItem",fn:function(ref){
var item = ref.item;
return [_c('v-checkbox',{attrs:{"input-value":item.selected},on:{"change":function($event){return _vm.selectItem(item)}}}),_c('div',[_vm._v(" "+_vm._s(item.user.email)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }